import axios from 'axios';
import {AxiosReadPayload} from '../../shared/service/axios-read-payload';
import {axiosReadHelper} from '../../shared/service/axios-read-helper';
import {axiosSaveHelper} from '../../shared/service/axios-save-helper';
import {AxiosSavePayload} from '../../shared/service/axios-save-payload';
import {AxiosResultStatus} from '../../shared/service/axios-result-status';
import {configSettings} from '../../shared/configuration/config-settings';

class MetaDataService{
  async getPatientEncounterMetaData(){
    const readPayload: AxiosReadPayload = {
      url: `patient-encounter/v2/patient/encounter/metaData`,
    };
    return await axiosReadHelper(readPayload);
  }
  async getPatientMetadata(){
    const readPayload: AxiosReadPayload = {
      url: `patient/v2/metadata`,
    };
    return await axiosReadHelper(readPayload);
  }

  async getPaymentChannels(){
    const readPayload: AxiosReadPayload = {
      url: `payment/v2/payment/paymentchannels`,
    };
    return await axiosReadHelper(readPayload);
  }

  async getPaymentsV3Metadata(){
    const readPayload: AxiosReadPayload = {
      url: `payments/v3/metadata`,
    };
    return await axiosReadHelper(readPayload);
  }

  async getAlerts(clientId: string | number) {
    const readPayload: AxiosReadPayload = {
      url: `estimation/v2/client/${clientId}/alert`,
      dataId:-2
    }
    return await axiosReadHelper(readPayload)
  }

  async getEmployers(clientId: string | number) {
    const readPayload: AxiosReadPayload = {
      url: `clients/v2/client/${clientId}/employer`,
      dataId:-2
    }
    return await axiosReadHelper(readPayload)
  }

  async createEmployer({clientId, employerName}: {clientId: number, employerName: string}) {
    const readPayload: AxiosSavePayload = {
      url: `clients/v2/client/${clientId}/employer`,
      dataToSave: {
        employerName
      },
      dataId:0
    }
    return await axiosSaveHelper(readPayload)
  }

  async patchClientAlert({ clientId, clientAlertId, note_body }: { clientId: number; clientAlertId: number; note_body: string }) {
    const payload: AxiosSavePayload = {
      url: `estimation/v2/client/${clientId}/alert/${clientAlertId}`,
      dataToSave: { note_body },
      isPatch: true,
      dataId: undefined,
    }
    return await axiosSaveHelper(payload)
  }

  async createClientAlert({ clientId, alert_type_id, note_body, alert_ref_id, prefix, group_code }: {
    clientId: number;
    alert_type_id: number;
    note_body: string;
    alert_ref_id?: string;
    prefix?: string;
    group_code?: string;
  }) {
    const payload: AxiosSavePayload = {
      url: `estimation/v2/client/${clientId}/alert`,
      dataToSave: { alert_type_id, note_body, note_title: null, alert_ref_id, prefix, group_code },
      dataId: 0,
    }
    return await axiosSaveHelper(payload)
  }

  async deleteClientAlert({ clientId, clientAlertId }: { clientId: number; clientAlertId: number }) {
    const result = new AxiosResultStatus();
    const url = `${configSettings.unified_aws_app_gateway_uri}/estimation/v2/client/${clientId}/alert/${clientAlertId}`;
    await axios.delete(url)
      .then(response => { result.entity = response.data; })
      .catch(error => {
        result.entity = error.response?.data;
        result.errorMessage = error.message;
        result.statusCode = error.response?.status;
      });
    result.hasErrors = result.errorMessage?.length > 0;
    return result;
  }

}

export const metaDataService = new MetaDataService();